/** Approximate an alpha mask for existing dark text on a flat background.
 * Keeps a moved PDF glyph's original shapes without a white rectangular crop.
 * Non-uniform backgrounds cannot be reliably separated and are left intact. */
export function transparentizeTextPixels(pixels,width,height) {
  if(width<3||height<3) return false;
  const index=(x,y)=>(y*width+x)*4;
  const corners=[[1,1],[width-2,1],[1,height-2],[width-2,height-2]];
  const bg=[0,1,2].map(k=>Math.round(corners.reduce((s,[x,y])=>s+pixels[index(x,y)+k],0)/4));
  const maxVariance=Math.max(...corners.flatMap(([x,y])=>bg.map((b,k)=>Math.abs(pixels[index(x,y)+k]-b))));
  if(maxVariance>32) return false;
  let fg=[0,0,0], largestDifference=-1;
  for(let y=0;y<height;y++) for(let x=0;x<width;x++) {
    const i=index(x,y),r=pixels[i],g=pixels[i+1],b=pixels[i+2];
    const difference=Math.max(Math.abs(r-bg[0]),Math.abs(g-bg[1]),Math.abs(b-bg[2]));
    if(difference>largestDifference){largestDifference=difference;fg=[r,g,b];}
  }
  const maximum=Math.max(...bg.map((b,k)=>Math.abs(b-fg[k])));
  if(maximum<30) return false;
  for(let i=0;i<pixels.length;i+=4) {
    const distance=Math.max(...bg.map((b,k)=>Math.abs(b-pixels[i+k])));
    const opacity=Math.min(1,Math.max(0,distance/maximum));
    pixels[i]=fg[0];pixels[i+1]=fg[1];pixels[i+2]=fg[2];
    pixels[i+3]=Math.round(opacity*255);
  }
  return true;
}
